import { ROUTES } from "../../../../../../setup/constants";
import styles from "./styles.module.scss";

interface LinkProps {
  text: string;
  contractId: string;
}

const Link = ({ text, contractId }: LinkProps) => {
  const handleRowClick = () => {
    window.open(
      `${ROUTES.CONTRACT_DETAILS.replace(":id", contractId)}`,
      "_blank"
    );
  };

  return (
    <div onClick={handleRowClick} className={styles.link}>
      {text}
    </div>
  );
};

export default Link;
